const suggestionSchema = {};

export default suggestionSchema;
